<template>
  <view class="popup-container">
    <uni-popup ref="popupRef" type="bottom" :mask-click="false" @maskClick="handleClosed">
      <view class="popup-header">
        <view class="closed-icon" @click="handleClosed">
          <text class="tripwisefont icon-guanbi_xianxing"></text>
        </view>
        <view class="popup-title">
          <text>{{ titleMsg }}</text>
        </view>
        <view class="popup-title-tips">
          <text>根据您的选择，为您{{ tipMsg }}</text>
        </view>
      </view>
      <view class="popup-content">
        <picker-view
          indicator-class="custom-picker-column"
          class="picker-view-item"
          @change="changePicker"
          :value="pickerValIndex"
          v-if="recommendChoiceList && recommendChoiceList.length > 0"
        >
          <picker-view-column>
            <view v-for="(item, index) in recommendChoiceList">
              <text>{{ item.Name }}</text>
            </view>
          </picker-view-column>
          <picker-view-column>
            <view class="" v-for="(item, index) in recommendChoiceList[pickerValIndex[0]].SubItemList">
              <text>{{ item.SubName }}</text>
            </view>
          </picker-view-column>
        </picker-view>
      </view>
      <view class="popup-footer">
        <button type="default" class="custom-button" @click="handleConfirm">{{ btnMsg }}</button>
        <view class="no-tips" @click="handleToSelectPlace" v-if="isShowFooterTips && this.greenAreaType == 1">
          <text>{{ fMsg }}</text>
          <text class="tripwisefont icon-icon_next_common arrow-right"></text>
        </view>
      </view>
    </uni-popup>
  </view>
</template>

<script>
export default {
  props: {
    isShowFooterTips: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    recommendChoiceList() {
      return this.$store.state.indexCar.locationInfo.RecommendChoiceList || [];
    },
    regeoCode() {
      return this.$store.state.indexCar.locationInfo.Regeocode || {};
    },
    greenAreaType() {
      return this.$store.state.indexCar.locationInfo.GreenAreaType;
    },
    greenAreaPlaceInfo() {
      return this.$store.state.indexCar.greenAreaInfo || {};
    },
    pointType() {
      return this.$store.state.indexCar.placeType;
    },
    titleMsg() {
      return this.pointType == 1 ? '请选择从哪儿出发' : '请选择到达区域';
    },
    tipMsg() {
      return this.pointType == 1 ? '推荐最方便上车点' : '推荐最佳下车点';
    },
    fMsg() {
      return this.pointType == 1
        ? `起点不在${this.greenAreaType == 1 ? '火车站' : '机场'}`
        : `不在该${this.greenAreaType == 1 ? '火车站' : '机场'}下车`;
    },
    btnMsg() {
      return this.pointType == 1 ? '确认上车点' : '确认下车点';
    },
  },
  data() {
    return {
      pickerValIndex: [0, 0],
      selectedLocation: [], // 所选择上车点经纬度
      show: true,
    };
  },
  methods: {
    // 关闭事件
    handleClosed() {
      /* 不选择目的地绿区地点时,  清除目的地信息*/
      if (this.pointType === 2) {
        this.$store.commit('setEndLocation', []);
        this.$store.commit('setEndPlaceInfo', {});
      }
      this.$refs.popupRef.close();
      this.$store.commit('setGreenPopupShow', false);
    },
    changePicker(e) {
      let pickerValIndex = [0, 0];
      this.$nextTick(() => {
        if (this.pickerValIndex[0] !== e.detail.value[0]) {
          pickerValIndex = [e.detail.value[0], 0];
        } else if (this.pickerValIndex[1] !== e.detail.value[1]) {
          pickerValIndex = e.detail.value;
        }
        this.pickerValIndex = pickerValIndex;
        let selectedItem = {};
        if (e.detail) {
          selectedItem = this.recommendChoiceList[this.pickerValIndex[0]].SubItemList[this.pickerValIndex[1]];
          this.selectedLocation = [selectedItem.Longitude, selectedItem.Latitude];
        }
      });
    },
    handleConfirm() {
      this.$nextTick(() => {
        this.$emit('confirm', this.selectedLocation);
        this.$refs.popupRef.close();
        this.$store.commit('setGreenPopupShow', false);
      });
    },
    openPopup() {
      this.$nextTick(() => {
        this.initPickerVal();
        this.$refs.popupRef.open();
        this.$store.commit('setGreenPopupShow', true);
      });
    },
    // 初始化picker选择器选中数值
    initPickerVal() {
      let firstIndex = 0; // 一级数据下下标
      let secondIndex = 0; // 二级数据下标
      let lat = '';
      let lon = '';
      if (this.regeoCode && Object.keys(this.regeoCode).length > 0) {
        if (!this.regeoCode.Location) {
          return;
        }
        lat = this.regeoCode.Location.split(',')[0];
        lon = this.regeoCode.Location.split(',')[1];
        this.recommendChoiceList.forEach((oVal, oIndex) => {
          if (oVal.SubItemList && oVal.SubItemList.length > 0) {
            oVal.SubItemList.forEach((sVal, sIndex) => {
              if (sVal.Latitude && sVal.Latitude === lat && sVal.Longitude && sVal.Longitude === lon) {
                firstIndex = oIndex;
                secondIndex = sIndex;
              }
            });
          }
        });
        this.pickerValIndex = [firstIndex, secondIndex];
        let selectedItem = this.recommendChoiceList[0].SubItemList[0];
        this.selectedLocation = [selectedItem.Longitude, selectedItem.Latitude];
      }
    },
    handleToSelectPlace() {
      this.$refs.popupRef.close();
      this.$store.commit('setGreenPopupShow', false);
      uni.navigateTo({
        url: '/pages/index3.0/carIndex/selectPlace',
      });
    },
  },
  mounted() {
    this.$store.commit('setGreenPopupShow', false);
  },
};
</script>

<style lang="scss" scoped scoped>
/deep/.uni-popup {
  .uni-popup__wrapper {
    .uni-popup__wrapper-box {
      padding: 0;
      border-radius: 16rpx 16rpx 0 0;
      background-color: #ffffff !important;

      .popup-header {
        padding: 60rpx 32rpx 36rpx 32rpx;
        // box-shadow: 0 8rpx 60rpx -11rpx rgba(97, 110, 124, 0.32);
        position: relative;
        border-bottom: 1rpx solid #ededed;

        .closed-icon {
          position: absolute;
          top: 32rpx;
          right: 32rpx;
          font-size: 32rpx;
          color: #000000;
        }

        .popup-title {
          font-size: 44rpx;
          font-weight: 500;
          line-height: 44rpx;
          color: #141414;
        }

        .popup-title-tips {
          font-size: 28rpx;
          font-weight: normal;
          line-height: 28rpx;
          margin-top: 24rpx;
        }
      }

      .popup-content {
        padding: 30rpx;
        height: 282rpx;

        .picker-view-item {
          height: 100%;

          /deep/.custom-picker-column {
            height: 74rpx;
          }

          .uni-picker-view-content {
            text-align: center;
            font-size: 32rpx;
            font-weight: normal;
            color: #141414;
            line-height: 74rpx;
          }
        }
      }

      .popup-footer {
        padding: 0 30rpx 30rpx 30rpx;

        .custom-button {
          height: 100rpx;
          line-height: 100rpx;
          border-radius: 12rpx;
          background: #f85a5b;
          font-family: PingFang SC;
          font-size: 32rpx;
          font-weight: 600;
          color: #ffffff;
        }

        .no-tips {
          font-size: 28rpx;
          font-weight: normal;
          color: #595959;
          justify-content: center;
          padding: 30rpx 0 0 0;
          display: flex;
          align-items: center;

          .arrow-right {
            font-size: 28rpx;
            color: #595959;
            margin-left: 12rpx;
          }
        }
      }
    }
  }
}

.van-popup__close-icon {
  color: #000 !important;
  font-size: 0.32rem !important;
}

.v-title {
  margin-top: 0.6rem;
  padding: 0 0.32rem;
  font-size: 0.44rem;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.44rem;
  font-weight: 600;
}

.v-tip {
  padding: 0 0.32rem;
  margin-top: 0.24rem;
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;
}

.v-com {
  color: #009c7d;
}

.v-wrap {
  /* 	margin-top: 0.16rem; */
  padding: 0 0.32rem;
  height: 2.56rem;
  padding-top: 0.16rem;
  /* 	overflow: hidden; */
}

.v-btn {
  margin: 0.28rem 0.36rem;
  height: 1rem;
  background: #0b1f43;
  border-radius: 0.12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.32rem;
  color: #ffffff;
  font-weight: 600;
}

.v-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.28rem;
  color: rgba(0, 0, 0, 0.6);
  line-height: 0.28rem;
}
</style>
